import { Platform } from "react-native";
import Config from "react-native-config";
import { APIService} from "../utilities/Constants";
import { apiPost } from "./utils/apiUtils";
import { AxiosRequestHeaders } from "axios";
import qs from "qs";
import { messages } from "../../src/resources/strings";

//Get access token -  to be used in sign up API
export const getAccessToken = async (scope: string) => {
  // Populate parameters with client(app specific) credentials
  let paramData: any = {
    client_id: `${
      Platform.OS === "web"
        ? process.env.REACT_APP_EXZEO_ID_CLIENT_ID
        : Config.REACT_APP_EXZEO_ID_CLIENT_ID
    }`,
    client_secret: `${
      Platform.OS === "web"
        ? process.env.REACT_APP_EXZEO_ID_CLIENT_SECRET
        : Config.REACT_APP_EXZEO_ID_CLIENT_SECRET
    }`,
    grant_type: "client_credentials",
  };

  if (scope) {
    paramData["scope"] = scope;
  }

  const params = qs.stringify(paramData);

  const header = {
    "Content-Type": "application/x-www-form-urlencoded",
  };

  const response = await apiPost(
    APIService.exzeo,
    "/oidc/token",
    params,
    { isUserAuthRequired: true },
    undefined,
    header as AxiosRequestHeaders
  );

  if (response.status === 200) {
    const data = response.data;
    return {
      response: data.access_token,
      errorCode: messages.error.noError,
    };
  } else {
    return {
      errorCode: messages.error.somthingWrong,
    };
  }
};
